/*

import glFlag from '../assets/flags/gl.png';
import euFlag from '../assets/flags/euskera.png';
import frlag from '../assets/flags/france.png';
import itFlag from '../assets/flags/italy.png';
import ptFlag from '../assets/flags/portugal.png';
import zhFlag from '../assets/flags/china.png';
import jaFlag from '../assets/flags/japan.png';
import ruFlag from '../assets/flags/russia.png';

export const languageFlags: Record<string, string> = {
  gl: glFlag,
  eu: euFlag,
  fr: frlag,
  it: itFlag,
  pt: ptFlag,
  zh: zhFlag,
  ja: jaFlag,
  ru: ruFlag
};

export const supportedLanguages = [
    { code: 'pt', nameKey: 'pt' },
    { code: 'fr', nameKey: 'fr' },
    { code: 'it', nameKey: 'it' },
    { code: 'gl', nameKey: 'gl' },
    { code: 'eu', nameKey: 'eu' },
    { code: 'zh', nameKey: 'zh' },
    { code: 'ja', nameKey: 'ja' },
    { code: 'ru', nameKey: 'ru' }
  ];
  
*/

import spainFlag from '../assets/flags/spain.png';
import cataloniaFlag from '../assets/flags/catalonia.png';
import usaFlag from '../assets/flags/usa.png';
import deFlag from '../assets/flags/germany.png';
import arFlag from '../assets/flags/saudiarabia.png';


export const languageFlags: Record<string, string> = {
  es: spainFlag,
  ca: cataloniaFlag,
  en: usaFlag,
  de: deFlag,
  ar: arFlag
};

export const supportedLanguages = [
    { code: 'es', nameKey: 'es' },
    { code: 'en', nameKey: 'en' },
    { code: 'ca', nameKey: 'ca' },
    { code: 'de', nameKey: 'de' },
    { code: 'ar', nameKey: 'ar' }
  ];
  